import type { ReactNode } from 'react';
import { LoaderCircle } from 'lucide-react';

export function PageHead({ eyebrow, title, copy, actions }: { eyebrow: string; title: string; copy: string; actions?: ReactNode }) {
  return <header className="page-head"><div><p className="eyebrow">{eyebrow}</p><h1>{title}</h1><p>{copy}</p></div>{actions && <div className="page-actions">{actions}</div>}</header>;
}

export function MetricCard({ label, value, note, icon, tone = 'teal' }: { label: string; value: ReactNode; note: string; icon: ReactNode; tone?: string }) {
  return <article className={`metric-card tone-${tone}`}><div className="metric-top"><span>{label}</span><i>{icon}</i></div><strong>{value}</strong><small>{note}</small></article>;
}

export function Panel({ title, subtitle, action, children, className = '' }: { title?: string; subtitle?: string; action?: ReactNode; children: ReactNode; className?: string }) {
  return <section className={`panel ${className}`}>{title && <header className="panel-head"><div><h3>{title}</h3>{subtitle && <p>{subtitle}</p>}</div>{action}</header>}{children}</section>;
}

export function Status({ value }: { value: string }) {
  const normalized = value.toLowerCase().replaceAll(' ', '-');
  return <span className={`status status-${normalized}`}>{value.replaceAll('_',' ')}</span>;
}

export function Loading({ label = 'Loading data...' }: { label?: string }) {
  return <div className="loading"><LoaderCircle className="spin" size={22} /><span>{label}</span></div>;
}

export function Empty({ children }: { children: ReactNode }) {
  return <div className="empty-state">{children}</div>;
}
